export default {
  'user-register.login.userName': '用户名',
  'user-register.login.password': '密码',
  'user-register.login.message-invalid-credentials': '账户或密码错误（admin/ant.design）',
  'user-register.login.message-invalid-verification-code': '验证码错误',
  'user-register.login.tab-login-credentials': '账户密码登录',
  'user-register.login.tab-login-mobile': '手机号登录',
  'user-register.login.remember-me': '自动登录',
  'user-register.login.forgot-password': '忘记密码',
  'user-register.login.sign-in-with': '其他登录方式',
  'user-register.login.signup': '注册账户',
  'user-register.login.login': '登录',
  'user-register.register.register': '注册',
  'user-register.register.get-verification-code': '获取验证码',
  'user-register.register.sign-in': '使用已有账户登录',
  'user-register.register-result.msg': '你的账户：{email} 注册成功',
  'user-register.register-result.activation-email':
    '激活邮件已发送到你的邮箱中，邮件有效期为24小时。请及时登录邮箱，点击邮件中的链接激活帐户。',
  'user-register.register-result.back-home': '返回首页',
  'user-register.register-result.view-mailbox': '查看邮箱',
  'user-register.email.required': '请输入邮箱地址！',
  'user-register.email.wrong-format': '邮箱地址格式错误！',
  'user-register.userName.required': '请输入用户名!',
  'user-register.password.required': '请输入密码！',
  'user-register.password.twice': '两次输入的密码不匹配!',
  'user-register.strength.msg': '请至少输入 6 个字符。请不要使用容易被猜到的密码。',
  'user-register.strength.strong': '强度：强',
  'user-register.strength.medium': '强度：中',
  'user-register.strength.short': '强度：太短',
  'user-register.confirm-password.required': '请确认密码！',
  'user-register.phone-number.required': '请输入手机号！',
  'user-register.phone-number.wrong-format': '手机号格式错误！',
  'user-register.verification-code.required': '请输入验证码！',
  'user-register.title.required': '请输入标题',
  'user-register.date.required': '请选择起止日期',
  'user-register.goal.required': '请输入目标描述',
  'user-register.standard.required': '请输入衡量标准',
  'user-register.form.get-captcha': '获取验证码',
  'user-register.captcha.second': '秒',
  'user-register.form.optional': '（选填）',
  'user-register.form.submit': '提交',
  'user-register.form.save': '保存',
  'user-register.email.placeholder': '邮箱',
  'user-register.password.placeholder': '至少6位密码，区分大小写',
  'user-register.confirm-password.placeholder': '确认密码',
  'user-register.phone-number.placeholder': '手机号',
  'user-register.verification-code.placeholder': '验证码',
  'user-register.title.label': '标题',
  'user-register.title.placeholder': '给目标起个名字',
  'user-register.date.label': '起止日期',
  'user-register.placeholder.start': '开始日期',
  'user-register.placeholder.end': '结束日期',
  'user-register.goal.label': '目标描述',
  'user-register.goal.placeholder': '请输入你的阶段性工作目标',
  'user-register.standard.label': '衡量标准',
  'user-register.standard.placeholder': '请输入衡量标准',
  'user-register.client.label': '客户',
  'user-register.label.tooltip': '目标的服务对象',
  'user-register.client.placeholder': '请描述你服务的客户，内部客户直接 @姓名／工号',
  'user-register.invites.label': '邀评人',
  'user-register.invites.placeholder': '请直接 @姓名／工号，最多可邀请 5 人',
  'user-register.weight.label': '权重',
  'user-register.weight.placeholder': '请输入',
  'user-register.public.label': '目标公开',
  'user-register.label.help': '客户、邀评人默认被分享',
  'user-register.radio.public': '公开',
  'user-register.radio.partially-public': '部分公开',
  'user-register.radio.private': '不公开',
  'user-register.publicUsers.placeholder': '公开给',
  'user-register.option.A': '同事甲',
  'user-register.option.B': '同事乙',
  'user-register.option.C': '同事丙',
  'user-register.navBar.lang': '语言',
};
